import { Component, OnInit,} from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  detail:string = 'Detail';

  constructor(private authenticationService:AuthenticationService, private titleService: Title) { }

  ngOnInit() {
    const stored = localStorage.getItem('company_name');
    if (stored) {
      this.detail = stored;
      this.titleService.setTitle(stored);
    }
  }
  refresh(e) {

    console.log("Refresh")
  }


}
